import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/marketing/made-in-canada/MadeInCanadaContent.tsx");
